import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentNewspaper: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 0h12v13.5h1.5V3H16v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3zm3 3h6v2H3zm4 5H3v2h4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default entertainmentNewspaper
